import { render, staticRenderFns } from "./ModerationStatus.vue?vue&type=template&id=b95777ae&"
import script from "./ModerationStatus.vue?vue&type=script&lang=js&"
export * from "./ModerationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports